import { useState } from "react";
import Home from "./pages/Home";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Contact from "./pages/Contact";
import Links from "./pages/Links";
import Navbar from "./components/Navbar";

function App() {
  const [sortType, setSortType] = useState("default");
  const [dateFilter, setDateFilter] = useState("week");
  
  return (
    <div className="min-h-screen overflow-y-auto bg-[#202020] text-white">
      <Router>
        {/* Navbar is displayed on all pages */}
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home sortType={sortType} setSortType={setSortType} dateFilter={dateFilter} setDateFilter={setDateFilter} />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/links" element={<Links />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
